import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, "第一步，修改初始密码", -1)
const _hoisted_2 = /*#__PURE__*/_createTextVNode("修改初始密码")
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "第二步，设置外部可访问链接", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "请设置可从外部访问本辅助程序的链接，用于PT管理宝小程序连接", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode("设置外部链接")
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", null, "第三步，设置完PtManageKey后，测试连接"),
  /*#__PURE__*/_createElementVNode("p", null, "请至“Pt管理宝”微信小程序进行连接测试")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "第四步，设置站点Cookie", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "登录各PT站后，获取cookie并填写", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("设置站点Cookie")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("完成，现在可以去小程序使用啦！")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_timeline_item = _resolveComponent("a-timeline-item")!
  const _component_a_timeline = _resolveComponent("a-timeline")!
  const _component_page_container = _resolveComponent("page-container")!

  return (_openBlock(), _createBlock(_component_page_container, {
    title: "首页",
    "sub-title": ""
  }, {
    content: _withCtx(() => [
      _createVNode(_component_a_timeline, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_1,
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.goRouteLink('SetPassword')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_3,
                _hoisted_4,
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.goRouteLink('PtManageKey')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_5
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _hoisted_7,
                _hoisted_8,
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goRouteLink('PtCookie')))
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_a_timeline_item, null, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}